// extracted by mini-css-extract-plugin
export default {"card-wrapper":"CreateFontCard_card-wrapper__e1FLy","card-inner-wrapper":"CreateFontCard_card-inner-wrapper__2pnpE","card-plus":"CreateFontCard_card-plus__lLEcP"};